module.exports = __webpack_public_path__ + "roboto-v15-latin-700.525d5b452809b3172a2a.woff";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/fonts/roboto-v15-latin-700.woff
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-700.woff
// module chunks = 2